var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 326.2 320.4",
    style: {
      enableBackground: "new 0 0 326.2 320.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6FDFC;}\n\t.st1{fill:#00D0E8;}\n\t.st2{opacity:0.3072;fill:#0095A6;enable-background:new    ;}\n\t.st3{fill:#00ACFF;}\n\t.st4{fill:#08E9DB;}\n\t.st5{opacity:0.272;fill:#0095DD;enable-background:new    ;}\n\t.st6{fill:#05D1DB;}\n\t.st7{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.3,296.2c4.7,2.1,9.2,3.8,13.6,5.3l-2.8-21L134.3,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.2,150.2l15.2-71.3c0.1-0.4,0.2-0.8,0.3-1.2l-0.2-0.1l0.7-1.8c4.1-16.7,12.4-32,24.1-44.5 C86.6,15.4,29.1,29.2,6.8,69.5c-18.5,33.4,2.9,97.7,41,150.6C75.5,175.6,95.3,152.3,107.2,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,280.4c1.8,1.3,3.6,2.5,5.4,3.7l-1.6-11L106.9,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.8,58.4c2.3,11.9,2.4,24.2,0.2,36.3l-0.1,1.9l-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2l-15.2,71.3 c10.1,6.8,18.8,36.6,26.1,89.4c0.3,2.2-1.2,4.2-3.4,4.5c-0.5,0.1-0.9,0-1.4-0.1l-39.4-8.4l-1.3,6.3l0,0c0,0.1,0,0.2-0.1,0.3l0,0 l0,0c-3.4,16-11.6,29.8-24.6,41.5c59.9,16.9,100.5-25.1,132.8-79C382.1,45.9,287.3,89,211.8,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.1,242.1l-0.4-0.2l1.3-6.3l-35.3-7.5c9.7,12.5,20.2,24.3,31.4,34.6C85,255.2,86,248.3,88.1,242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.7,261.2l-8,2.1c-12.2,3.3-25.1,2.9-37.2-0.9c-22.8-7.3-36-13.6-39.5-18.7l-3.9-1.6 c-2.1,6.2-3.1,13.1-3,20.7c0.3,12.1,3.4,25.8,9.5,41.3l12.2-23.6l3.8-7.3l1.6,11l5.3,36.3l16.7-24.3l10.8-15.7l2.8,21l0.6,4.3 c1.2-1,2.4-2,3.6-3.1C165.1,291,173.2,277.2,176.7,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.7,261.2c0-0.1,0-0.2,0.1-0.3l-0.6,0L176.7,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.7,261.2L176.7,261.2C176.7,261.2,176.7,261.2,176.7,261.2L176.7,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.7,261.2L176.7,261.2C176.7,261.2,176.7,261.2,176.7,261.2L176.7,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.3,260.2c-12.4-0.3-24.7-2.9-36.2-7.7L92,243.7c3.5,5.1,16.7,11.3,39.5,18.7c12,3.9,24.9,4.2,37.2,0.9 l8-2.1c0,0,0,0,0,0l-0.6-0.4L149.3,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.3,260.2c-12.4-0.3-24.7-2.9-36.2-7.7L92,243.7c3.5,5.1,16.7,11.3,39.5,18.7c12,3.9,24.9,4.2,37.2,0.9 l8-2.1c0,0,0,0,0,0l-0.6-0.4L149.3,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.9,213.1L93.9,213.1l13.4-63c-11.9,2.1-31.8,25.4-59.5,69.9c-0.2,0.4-0.5,0.7-0.7,1.1 c-1.2,1.9-0.6,4.3,1.3,5.5c0.4,0.2,0.8,0.4,1.3,0.5l4.1,0.9l35.3,7.5L93.9,213.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.3,230.1l-5.2,24.5l39.4,8.4c0.5,0.1,0.9,0.1,1.4,0.1c2.2-0.3,3.7-2.3,3.4-4.5 c-7.2-52.8-15.9-82.6-26.1-89.4L183.3,230.1L183.3,230.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.5,74.8l28.7,10.9c9.1,3.4,18.6,5.5,28.3,6.2l1,0.1l30.6,1.7l-0.1,1.1c2.2-12.1,2.1-24.4-0.2-36.3 c-1.6-8.6-4.4-17.1-8.3-25.1L188.4,2.3c-0.1-0.3-0.3-0.6-0.5-0.8c-1.4-1.7-3.9-1.9-5.6-0.5l-26.4,22.2c-3,2.6-5.9,5.3-8.6,8.2 c-11.7,12.5-20,27.8-24.1,44.5L123.5,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.1,88.8l-1-0.4l-28.4-10.8c-0.1,0.4-0.2,0.8-0.3,1.2l-15.2,71.3l-13.4,63l0,0l-4.8,22.5l-1.3,6.3l0.4,0.2 l3.9,1.6l21.1,8.8c11.5,4.8,23.8,7.4,36.2,7.7l26.8,0.6l0.6,0l0,0l1.3-6.3l5.2-24.5l0,0l13-61l15.2-71.3c0.1-0.4,0.2-0.8,0.2-1.2 l-30.3-1.7C171.3,94.3,161.5,92.3,152.1,88.8z M144.5,119.1c2-9.5,11.3-15.5,20.8-13.5c6.1,1.3,10.8,5.6,12.8,11.1 c2.1,3.7,2.9,8.1,2,12.6c-2.1,9.7-11.6,15.9-21.3,13.9c-8.3-1.8-14.1-9.1-14.2-17.2C144,123.8,144,121.5,144.5,119.1z M143.5,252 l-0.2,0.1c-4,0.9-8.2,0.1-11.5-2.2c-2.4-1.6-4.1-4-5-6.6c-1.3-0.9-1.9-2.5-1.6-4.1l0.6-2.9l0,0l0,0l16-75.3 c0.5-2.2,2.6-3.5,4.7-3.1l13.7,2.9c2.2,0.5,3.5,2.6,3.1,4.7l-9.1,43l0.1-0.1l-2.3,22.2l-1.3,13.3 C150.2,247.9,147.3,251.2,143.5,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.9,230.7l2.3-22.2l-0.1,0.1l-7.5,35.3c-0.5,2.2-2.6,3.5-4.7,3.1l-13.7-2.9c-0.6-0.1-1.1-0.4-1.5-0.7 c0.9,2.7,2.7,5,5,6.6c3.4,2.3,7.5,3.1,11.5,2.2l0.2-0.1c3.9-0.9,6.7-4.1,7.1-8.1L151.9,230.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M151.9,230.7l2.3-22.2l-0.1,0.1l-7.5,35.3c-0.5,2.2-2.6,3.5-4.7,3.1l-13.7-2.9c-0.6-0.1-1.1-0.4-1.5-0.7 c0.9,2.7,2.7,5,5,6.6c3.4,2.3,7.5,3.1,11.5,2.2l0.2-0.1c3.9-0.9,6.7-4.1,7.1-8.1L151.9,230.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "125.7,236.3 125.7,236.3 125.7,236.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "125.7,236.3 125.7,236.3 125.7,236.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.9,246.9c2.2,0.5,4.3-0.9,4.7-3.1l7.5-35.3l9.1-43c0.5-2.2-0.9-4.3-3.1-4.7l-13.7-2.9 c-2.2-0.5-4.3,0.9-4.7,3.1l-16,75.3l0,0l-0.6,2.9c-0.3,1.6,0.3,3.2,1.6,4.1c0.4,0.3,0.9,0.5,1.5,0.7L141.9,246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.5,91.9l-1-0.1c-9.7-0.7-19.2-2.7-28.3-6.2l-28.7-10.9l-0.4,1l-0.7,1.8l0.2,0.1l28.4,10.8l1,0.4 c9.4,3.4,19.2,5.5,29.2,6.1l30.3,1.7l0.3,0l0.1-1.9l0.1-1.1L181.5,91.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M178.8,126.4c-2,9.5-11.3,15.5-20.8,13.5c-7.1-1.5-12.3-7.2-13.6-13.9c0.2,8.2,5.9,15.5,14.2,17.2 c9.7,2.1,19.3-4.1,21.3-13.9c1-4.5,0.1-8.9-2-12.6C179.1,119.7,179.5,123,178.8,126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158,139.9c9.5,2,18.7-4,20.8-13.5c0.7-3.4,0.4-6.7-0.7-9.7c-2-5.4-6.7-9.8-12.8-11.1c-9.5-2-18.7,4-20.8,13.5 c-0.5,2.3-0.5,4.6-0.1,6.8C145.7,132.7,150.9,138.4,158,139.9z M174.8,125.6c-1.6,7.3-8.7,11.9-16,10.4c-7.3-1.6-11.9-8.7-10.4-16 c1.6-7.3,8.7-11.9,16-10.4C171.7,111.1,176.4,118.3,174.8,125.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9848 -0.1739 0.1739 0.9848 -18.8873 29.9815)",
    className: "st7",
    cx: 161.6,
    cy: 122.8,
    rx: 13.5,
    ry: 13.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.f0c00dcf0e1f824f6eda0abadcbcdacb.svg";
export { ForwardRef as ReactComponent };